// extracted by mini-css-extract-plugin
export default {"homeContainer":"home_homeContainer__TidJp"};